import {
  userEntered,
  userPlacedBet,
  userCanceledBet,
  userExited,
  userCashouted,
} from "./roundUserUpdate"

export const roundUserUpdateHelper = (setUsers, newUser, setCashoutedUser) => {
  switch (newUser.state) {
    case 1:
      setUsers((users) => userEntered(users, newUser))
      break
    case 2:
      setUsers((users) => userPlacedBet(users, newUser))
      break
    case 3:
      setUsers((users) => userCanceledBet(users, newUser))
      break
    case 4:
      setUsers((users) => userExited(users, newUser))
      break
    case 5:
      setCashoutedUser(newUser.id)
      setUsers((users) => userCashouted(users, newUser))
      break
    default:
      break
  }
}